import LanguageIcon from '@mui/icons-material/Language';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import { JSX, MouseEvent, useState } from 'react';
import ReactCountryFlag from 'react-country-flag';
import { useTranslation } from 'react-i18next';
import { languages } from '../../config';

export interface Language {
  code: string;
  name: string;
  countryCode: string;
}

export const LanguageSelector = (): JSX.Element => {
  const [menuAnchorElement, setMenuAnchorElement] = useState<null | HTMLElement>(null);
  const { i18n } = useTranslation();

  const openMenu = (event: MouseEvent<HTMLButtonElement>): void => {
    setMenuAnchorElement(event.currentTarget);
  };

  const hideMenu = (): void => {
    setMenuAnchorElement(null);
  };

  const changeLanguage = async (languageCode: string): Promise<void> => {
    await i18n.changeLanguage(languageCode);
    hideMenu();
  };

  const isMenuOpened = Boolean(menuAnchorElement);

  return <Box>
    <IconButton onClick={openMenu} role="button">
      <LanguageIcon />
    </IconButton>
    <Menu
      anchorEl={menuAnchorElement}
      open={isMenuOpened}
      onClose={hideMenu}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}
    >
      {languages.map(language => <MenuItem
        onClick={async () => await changeLanguage(language.code)}
        key={language.code}
      >
        <ReactCountryFlag countryCode={language.countryCode} />
        <Box sx={{ ml: 2 }}>{language.name}</Box>
      </MenuItem>)}
    </Menu>
  </Box>;
};
